var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-(3)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8763 16.9071L23.8688 24.2009C24.0486 24.3888 24.043 24.6875 23.8557 24.8683C23.7644 24.9561 23.6472 25 23.5296 25C23.4058 25 23.2825 24.9519 23.1903 24.8551L16.1808 17.5433C14.4697 18.9664 12.2744 19.824 9.88241 19.824C4.43297 19.824 0 15.3778 0 9.91202C0 4.44625 4.43297 0 9.88241 0C15.3319 0 19.7648 4.44625 19.7648 9.91202C19.7648 12.6397 18.6599 15.113 16.8763 16.9071ZM0.941182 9.91202C0.941182 14.8572 4.95203 18.88 9.88241 18.88C14.8123 18.88 18.8236 14.8572 18.8236 9.91202C18.8236 4.96687 14.8128 0.944002 9.88241 0.944002C4.95203 0.944002 0.941182 4.96687 0.941182 9.91202Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.057a0f1bbaa9d4b532add9de52dbcce9.svg";
export { ForwardRef as ReactComponent };